export default __webpack_public_path__ + "static/media/PAFI_Pengumuman RUPS 2024.0cbdddd3.pdf";